<p-toast position="top-right"></p-toast>
<div class="container">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-8">
        <lib-page-header page-title="Despesa Empenhada por Função de Governo"
          page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/desktop.png">
        </lib-page-header>
      </div>
      <div class="col-md-4">
        <a [routerLink]="['/']" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
      </div>
    </div>

    <div class="row">
      <div class="col-md">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" class="text-center">Código</th>
              <th scope="col" class="text-left">Descrição</th>
              <th scope="col" class="text-right">Valor Empenhado</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaFuncao">
              <th scope="row" class="text-center">{{(item.codigo)}}</th>
              <td>{{item.nome}}</td>
              <td class="text-right">{{item.empenhado | number:'1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
